import { IonAlert } from '@ionic/react';

interface LeaveLeagueAlertProps {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

export const LeaveLeagueAlert = ({ isOpen, onDismiss, onConfirm }: LeaveLeagueAlertProps) => (
  <IonAlert
    isOpen={isOpen}
    onDidDismiss={onDismiss}
    header="Abandonar liga"
    message="¿Seguro que quieres abandonar esta liga? Perderás tu equipo, tus pujas y tus ofertas. Si eres el último participante, la liga se eliminará."
    buttons={[
      { text: 'Cancelar', role: 'cancel' },
      { text: 'Abandonar', role: 'destructive', handler: onConfirm },
    ]}
  />
);
